import { PropertyType } from '../../../common';

export const mapApiToEntity = (data: PropertyType): PropertyType => {
	return {
		gameProvider: data,
	};
};

export const mapEntityToApi = (data: PropertyType): PropertyType => {
	const { token, gameProvider } = data;

	const apiData: PropertyType = {
		sid: token,
		main_provider_id: gameProvider.main_provider_id,
	};

	return apiData;
};
